import { useAlertModal } from '../components/AlertModalProvider';

/**
 * D2-polish: confirm-on-delete helper.
 *
 * Pops a centred modal asking the user to confirm a soft-delete. The cancel
 * button is auto-focused so a hurried Enter doesn't fire the destructive
 * action. Used everywhere the app exposes a Delete button or trash icon.
 *
 * Usage:
 *   const confirmDelete = useConfirmDelete();
 *   <ActionIcon onClick={() => confirmDelete('person', () => del.mutate(id))} />
 */
export function useConfirmDelete() {
  const { confirm } = useAlertModal();

  return async (entityLabel: string, action: () => void): Promise<void> => {
    const ok = await confirm({
      title: `Delete this ${entityLabel}?`,
      message:
        'The record will be soft-deleted (recoverable until purged). ' +
        'Are you sure you want to continue?',
      confirmLabel: 'Yes, delete',
      cancelLabel: 'No',
      destructive: true,
    });
    if (ok) action();
  };
}
